import { useDefaultImage } from 'utils/hooks/useDefaultImage';
// Styles
import useTranslations, { RU_LANGUAGE, UK_LANGUAGE } from 'languages';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { BrandsResponseType, CompaniesResponseType } from 'types/api/itemsResponseType';
import { useCheckPlug } from 'utils/CheckPlug';
import { useLink } from 'utils/hooks/useLink';
import {
  RelatedCompaniesAndBrandsDescription,
  RelatedCompaniesAndBrandsItemImg,
  RelatedCompaniesAndBrandsItemLink,
  RelatedCompaniesAndBrandsItemTitle,
  RelatedCompaniesAndBrandsItemWrap,
  RelatedCompaniesAndBrandsOtherMaterials,
} from './style';

interface PropsType {
  item: BrandsResponseType & CompaniesResponseType;
}

export const RelatedCompaniesAndBrandsItem: FC<PropsType> = ({ item }) => {
  const t = useTranslations();

  const { s3, seo, translation, logo } = { ...item };

  const { logo: logoMain = '', name } = { ...translation };

  const {
    slug_ru = '',
    slug_en = '',
    slug_uk = '',
    title_uk = '',
    title_ru = '',
    title_en = '',
  } = seo;

  const { defaultImage } = useDefaultImage(
    logo || '',
    s3 || '',
    logoMain || '',
    undefined,
    undefined
  );

  const link = useLink();

  const { locale = '' } = useRouter();

  const slugDiferLang =
    locale === UK_LANGUAGE ? slug_uk : locale === RU_LANGUAGE ? slug_ru : slug_en;

  const href =
    'rating' in item
      ? `${link}/companies/${slugDiferLang}`
      : `${link}/brands/${slugDiferLang}`;

  const linkPlug = useCheckPlug();
  const brandOrCompany = 'rating' in item ? 'companies' : 'brands';

  return (
    <RelatedCompaniesAndBrandsItemWrap>
      <RelatedCompaniesAndBrandsItemImg
        src={defaultImage}
        alt={name || title_en || title_ru || title_uk || 'default Logo'}
      />
      {name ? (
        <>
          <RelatedCompaniesAndBrandsItemTitle>{name}</RelatedCompaniesAndBrandsItemTitle>
          <RelatedCompaniesAndBrandsOtherMaterials href={href}>
            {'rating' in item
              ? t('Article.OtherCompanyMaterials')
              : t('Article.OtherBrandMaterials')}
          </RelatedCompaniesAndBrandsOtherMaterials>
        </>
      ) : (
        <RelatedCompaniesAndBrandsDescription>
          {t('textForUntranslatedArticleFirstPart')}
          {title_en && (
            <>
              <RelatedCompaniesAndBrandsItemLink
                href={`/en/${linkPlug}/${brandOrCompany}/${slug_en}`}
              >
                {title_en}
              </RelatedCompaniesAndBrandsItemLink>
              {t('versionArticleEn')}
            </>
          )}
          {title_ru && (
            <>
              <RelatedCompaniesAndBrandsItemLink
                href={`/ru/${linkPlug}/${brandOrCompany}/${slug_ru}`}
              >
                {title_ru}
              </RelatedCompaniesAndBrandsItemLink>
              {t('versionArticleRu')}
            </>
          )}
          {title_uk && (
            <>
              <RelatedCompaniesAndBrandsItemLink
                href={`${linkPlug}/${brandOrCompany}/${slug_uk}`}
              >
                {title_uk}
              </RelatedCompaniesAndBrandsItemLink>
              {t('versionArticleUk')}
            </>
          )}
        </RelatedCompaniesAndBrandsDescription>
      )}
    </RelatedCompaniesAndBrandsItemWrap>
  );
};
